var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        "hide-footer": "",
        "modal-class": "email-attachment-modal",
        size: "lg",
        title: "Anhänge",
        visible: _vm.show && _vm.emailId !== null,
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("hidden")
        },
      },
    },
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-center pt-4" },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading
        ? _c(
            "div",
            [
              _vm.attachments.length === 0
                ? _c("b-alert", { attrs: { show: "", variant: "info" } }, [
                    _vm._v(
                      "\n            Diese E-Mail enthält keine herunterladbaren Anhänge.\n        "
                    ),
                  ])
                : _c("b-table", {
                    attrs: {
                      borderless: "",
                      fields: _vm.tableFields,
                      items: _vm.attachments,
                      responsive: "",
                      striped: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(actions)",
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "table-actions d-flex" },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.openAttachmentUrl(item),
                                        target: "_blank",
                                        title: "In neuem Tab öffnen",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "inticon-autoclaim_detail",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.downloadAttachmentUrl(item),
                                        target: "_blank",
                                        title: "Herunterladen",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "inticon-autoclaim_einzeldownload",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2838273926
                    ),
                  }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }